import {
  VStack,
  Text,
  List,
  ListItem,
  ListIcon,
  Icon,
  HStack,
  RichText,
  useTheme,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { hasRichText } from '../../../utils/textUtils';
import GrayTextBox from '../../../components/GrayTextBox';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import { useLocale } from '../../../../../i18n';

const WelcomeText: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { distribution } = useAuth();
  const { userLang } = useLocale();
  const goalText =
    distribution?.localized_goal?.[userLang] || distribution?.goal;
  const offerText =
    distribution?.localized_offer?.[userLang] || distribution?.offer;

  return (
    <VStack spacing="6" align="stretch">
      <Text textStyle="h6Headline" textAlign="center">
        {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_TITLE')}
      </Text>
      <VStack align="stretch" spacing="6">
        <GrayTextBox title={t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_GOAL')}>
          {goalText && hasRichText(goalText) ? (
            <RichText color={colors.text.gray} value={goalText} />
          ) : (
            <List spacing="2" listStylePosition="outside">
              <CheckmarkListItem>
                {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_GOAL-SUPPORT')}
              </CheckmarkListItem>
              <CheckmarkListItem>
                {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_GOAL-STRENGTHEN')}
              </CheckmarkListItem>
              <CheckmarkListItem>
                {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_GOAL-OPTIMISE')}
              </CheckmarkListItem>
            </List>
          )}
        </GrayTextBox>
        <GrayTextBox title={t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_OFFER')}>
          {offerText && hasRichText(offerText) ? (
            <RichText color={colors.text.gray} value={offerText} />
          ) : (
            <List spacing="2" listStylePosition="outside">
              <CheckmarkListItem>
                {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_OFFER-ONE')}
              </CheckmarkListItem>
              <CheckmarkListItem>
                {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_OFFER-TWO')}
              </CheckmarkListItem>
              <CheckmarkListItem>
                {t('COMPANY-SCAN_INTRO-TO-OFFICE_EXPECT_OFFER-THREE')}
              </CheckmarkListItem>
            </List>
          )}
        </GrayTextBox>
      </VStack>
    </VStack>
  );
};

const CheckmarkListItem: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const CheckmarkIcon: React.FC<React.PropsWithChildren<unknown>> = () => (
    <Icon name="GeneralStatusSuccessCheckmark" color="primary.500" />
  );

  return (
    <ListItem as={HStack} spacing="2" align="flex-start">
      <ListIcon as={CheckmarkIcon} />
      <Text color="text.gray" textStyle="smallBody">
        {children}
      </Text>
    </ListItem>
  );
};

export default WelcomeText;
